import React from 'react';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';

export type UserCoupon = {
  code: string;
  name: string;
  discountType: 'FIXED' | 'PERCENTAGE';
  discountValue: number;
  maxDiscountAmount: number;
  minPurchaseAmount: number | null;
  purchaseState: string | null;
  expiresAt: string | null;
  status: 'AVAILABLE' | 'RESERVED';
  reservedUntil: string | null;
  includedPartnerNames: string[] | null;
  excludedPartnerNames: string[] | null;
};

export type GetUserCouponsResponse = { data: { coupons: UserCoupon[] } };

export function getUserCoupons(token: string, condition = true) {
  const [coupons, setCoupons] = React.useState<UserCoupon[] | null>(null);
  const {
    data, error, isLoading,
  }: { data: GetUserCouponsResponse; error?: boolean; isLoading: boolean } = useSWR(
    condition ? [`${process.env.REACT_APP_API_URL}/client/coupons`, 'GET', null, token] : null,
    ([url, method, body]) => fetcher(url, method, body, token),
  );
  React.useEffect(() => {
    if (data) {
      setCoupons(data.data.coupons);
    }
  }, [data]);
  return {
    coupons,
    couponsLoading: isLoading,
    couponsError: error,
  };
}
